import {EvkOption} from "@evomatik/evk-common";

export class WizardInformacion {
    id?: string;
    idWizardGenerado?: string;
    edicion?: boolean;
    titulo?: string;
    folioNegocio?: string;
    descripcion?: string;
    categoria?: string;
    duracion?: number;
    pasos?: PasoWizard[];
    totalPasos?: number;
    createdBy?: string;
    created?: string;
    updatedBy?: string;
    updated?: string;
    folioDiligencia?: string;
    idDiligencia?: string;
}

export class PasoWizard {
    titulo?: string;
    descripcion?: string;
    orden?: number;
    nombre?: string;
    discriminador?: string;
    metadataFormId?: string;
    ui?: any;
    requerido?: boolean;
    origen?: string;
    inData?: any;
    outData?: any;
    icon?: any;
    generarFolio?: boolean
    datosAdicionales?: any;
    cardinalidad?: string;
    idBandeja?: string;
    formatos?: EvkOption[];

    static toWizardStep(conf): PasoWizard {
        const wizarStep = new PasoWizard();
        return Object.assign(wizarStep, conf);
    }

    displayFn?: () => boolean = ()  => true;
}
